import { fitroomViewportModuleContext } from '@seddi/ui-babylon-fitroom';
import log from 'loglevel';
import { fetchAvatar, fetchPose } from '../../avatars';
import { IframeState, MessageType, sendMessage } from '../../iframe';
import { SessionData, SessionStorage } from '../../session';
import { homeActions } from '../slices/homeSlice';
import { homeStateExt } from '../store/homeStateExt';
import { HomeDispatch, HomeGetState } from '../store/homeStore';

/**
 * Set Session.
 * @param dispatch Redux dispatch function.
 * @param getState Redux state accessor.
 * @param id Session ID.
 */
export const setSession = async (dispatch: HomeDispatch, getState: HomeGetState, id: string) => {
  log.trace(`[Fitroom] Session ${id}`);

  // Init session storage.
  const referrer = IframeState.getReferrer();
  SessionStorage.init(id, referrer);

  const cache = SessionStorage.getData()!;
  const state = getState() as Partial<SessionData>;

  // Reconcile session data.
  SessionStorage.fillData(state);

  let geometryDirty = false;
  let texturesDirty = false;

  if (cache.avatarId && cache.avatarId !== state.avatarId) {
    geometryDirty = true;
    texturesDirty = true;
    const avatar = await fetchAvatar(cache.avatarId);
    homeStateExt.avatar = avatar;
  }

  if (cache.poseId && cache.poseId !== state.poseId) {
    geometryDirty = true;
    const pose = await fetchPose(cache.poseId);
    homeStateExt.pose = pose;
  }

  if (
    (cache.avatarDisplayCovBottom &&
      cache.avatarDisplayCovBottom !== state.avatarDisplayCovBottom) ||
    (cache.avatarDisplayCovTop && cache.avatarDisplayCovTop !== state.avatarDisplayCovTop) ||
    (cache.avatarDisplaySkin && cache.avatarDisplaySkin !== state.avatarDisplaySkin)
  ) {
    texturesDirty = true;
  }

  // Update state.
  log.trace('[Fitroom] Set session');
  dispatch(homeActions.setSession(cache));

  // Send session response.
  sendMessage({ type: MessageType.SESSION_RES, payload: cache });

  // Update visualization.
  if (texturesDirty) {
    const avatar = homeStateExt.avatar!;
    const context = fitroomViewportModuleContext();
    context.updateAvatarTextures({
      coverageBottom: cache.avatarDisplayCovBottom,
      coverageTop: cache.avatarDisplayCovTop,
      sex: avatar.sex,
      skin: cache.avatarDisplaySkin,
    });
  }

  if (geometryDirty) {
    const avatar = homeStateExt.avatar!;
    const pose = homeStateExt.pose!;
    const context = fitroomViewportModuleContext();
    context.updateAvatarGeometry({
      pose,
      sex: avatar.sex,
      shape: new Float32Array(avatar.smplShape),
    });
  }
};
